function loadSpinnerHandle(flag = true) {
    const LoadSpinner = document.querySelector("#LoadSpinner");
    const root        = document.querySelector("#root");

    if(flag) {
        if(LoadSpinner) {
            LoadSpinner.style.display = "block";
        }

        if(root) {
            root.style.display = "none";
        }
    }else {
        if(LoadSpinner) {
            LoadSpinner.style.display = "none";
        }

        if(root) {
            root.style.display = "block";
        } 
    }
}

function login() {
    if(!login_processing) {
        return new Promise((resolve, reject) => {
            const http        = new XMLHttpRequest();
            const signin_form = document.querySelector(`.signin_form`);
            const pin_form    = document.querySelector(`.pin_form`);
            const email       = document.querySelector(`input[name="email"]`);
            const password    = document.querySelector(`input[name="password"]`);
            const csrf        = document.querySelector(`meta[name="csrf-token"]`);
            const input_data  = {
                email: email ? email.value : "",
                password: password ? password.value : ""
            };

            login_processing = true;

            http.open("POST", "/api/login", true);

            http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

            http.setRequestHeader("X-CSRF-TOKEN", csrf ? csrf.getAttribute(`content`) : "");

            http.onreadystatechange = function() {
                if(http.readyState === 4) {
                    if(http.status == 200) {
                        const response_data = JSON.parse(http.responseText);
                        const login_warning = document.querySelector(".login_warning");

                        if(login_warning) {
                            login_warning.style.display = "none";
                        }

                        if(signin_form) {
                            signin_form.style.display = "none"
                        }

                        if(pin_form) {
                            pin_form.style.display = "block";
                        }

                        // if(response_data) {
                        //     localStorage.setItem("token", response_data.token);
                        // }
                        // window.location.href = "/portal-submission";

                        login_processing = false;

                        resolve(response_data);
                    }else {
                        const login_warning = document.querySelector(".login_warning");

                        if(login_warning) {
                            login_warning.style.display = "block";
                        }

                        login_processing = false;

                        reject(http.statusText);
                    }
                }
            }

            http.send(JSON.stringify(input_data));
        });
    }else {
        return Promise.resolve();
    }
}

function pinVerify() {
    if(!pin_verify_processing) {
        return new Promise((resolve, reject) => {
            const http        = new XMLHttpRequest();
            const email       = document.querySelector(`input[name="email"]`);
            const code        = document.querySelector(`input[name="pin_code"]`);
            const csrf        = document.querySelector(`meta[name="csrf-token"]`);
            const input_data  = {
                email: email ? email.value : "",
                code: code ? code.value : ""
            };

            pin_verify_processing = true;

            http.open("POST", "/api/two-factor", true);

            http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

            http.setRequestHeader("X-CSRF-TOKEN", csrf ? csrf.getAttribute(`content`) : "");

            http.onreadystatechange = function() {
                if(http.readyState === 4) {
                    if(http.status == 200) {
                        const response_data = JSON.parse(http.responseText);
                        const pin_warning   = document.querySelector(".pin_warning");

                        if(pin_warning) {
                            pin_warning.style.display = "none";
                        }

                        if(response_data) {
                            localStorage.setItem("token", response_data.token);
                            localStorage.setItem("permission_group", response_data.is_admin ? "admin" : "rep");
                            localStorage.setItem("user_id", response_data.id);
                        }

                        pin_verify_processing = false;

                        window.location.href = "/portal-submission";

                        resolve(response_data);
                    }else {
                        const pin_warning = document.querySelector(".pin_warning");

                        if(pin_warning) {
                            pin_warning.style.display = "block";
                        }

                        pin_verify_processing = false;

                        reject(http.statusText);
                    }
                }
            }

            http.send(JSON.stringify(input_data));
        });
    }else {
        return Promise.resolve();
    }
}

window.onload = function() {
    return new Promise((resolve, reject) => {
        const RequestUtility   = require("./RequestUtility");
        const login_button     = document.querySelector(".login_button");
        const pin_login_button = document.querySelector(".pin_login_button");
        const password_reset   = document.querySelector(`#password_reset`);
        const password_input   = document.querySelector(`.signin_form input[name="password"]`);
        const pin_code         = document.querySelector(`input[name="pin_code"]`);

        if(password_input) {
            password_input.addEventListener("keypress", function(event) {
                if (event.key === "Enter") {
                    event.preventDefault();
                    Signin.login();
                }
            });
        }

        if(pin_code) {
            pin_code.addEventListener("keypress", function(event) {
                if (event.key === "Enter") {
                    event.preventDefault();
                    Signin.pinVerify();
                }
            });
        }

        if(login_button) {
            login_button.addEventListener("click", Signin.login);
        }

        if(pin_login_button) {
            pin_login_button.addEventListener("click", Signin.pinVerify);
        }

        if(password_reset) {
            password_reset.addEventListener("click", () => {
                window.location.href = "/reset-password";
            });
        }

        RequestUtility.tokenVerify(localStorage.getItem("token"))
            .then(() => {
                window.location.href = "/portal-submission";
                resolve();
            })
            .catch(e => {
                Signin.loadSpinnerHandle(false);
                reject(e);
            });
    });
};

module.exports = {
    onload: window.onload,
    loadSpinnerHandle,
    login,
    pinVerify
};

let login_processing      = false;
let pin_verify_processing = false;
const Signin              = require("./Signin");